import { useCookieCheck } from '@psyomics/ui-common';
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import { GenericError } from '../../../molecules/generic-error/generic-error';

const RequireCookies = () => {
  const { status, startCookieCheck } = useCookieCheck();

  useEffect(() => {
    startCookieCheck();
  }, [startCookieCheck]);

  if (status === 'checking') return null;
  if (status === 'blocked') {
    return (
      <GenericError subtitleKey="common.errors.cookiesBlocked.subtitle" titleKey="common.errors.cookiesBlocked.title" />
    );
  }

  return <Outlet />;
};

export { RequireCookies };
